import { FieldValues, UseFormSetValue } from "react-hook-form";

import { IUserRoleItem } from "./table-user-roles.models";

export const checkUserRoleListFieldData = (
  watchedList: unknown,
  fieldName: string,
  setValue: UseFormSetValue<FieldValues>,
): IUserRoleItem[] => {
  if (watchedList && !Array.isArray(watchedList)) {
    /* guard for invalid value coming from backend*/
    setValue(fieldName, []);
  }

  return watchedList as IUserRoleItem[];
};

export const isRoleFromOtherCompany = ({
  roleCompanyId,
  ownCompanyId,
}: {
  roleCompanyId: number | null | undefined;
  ownCompanyId: number;
}): boolean => Boolean(roleCompanyId && Number(roleCompanyId) !== ownCompanyId);
